import "./src/styles/global.css";
import { CookieConsentBanner } from "./src/components/CookieConsentBanner";
import { CookieConsentProvider } from "./src/contexts/CookieConsentContext";
import { LanguageProvider } from "./src/contexts/LanguageContext";
import { getStoredCookieConsent } from "./src/utils/cookie-consent";

export const wrapPageElement = ({ element, props }) => (
  <LanguageProvider location={props.location}>
    <CookieConsentProvider>
      {element}
      <CookieConsentBanner />
    </CookieConsentProvider>
  </LanguageProvider>
);

export const onRouteUpdate = ({ location }) => {
  if (
    typeof window !== "undefined" &&
    window.gtag &&
    getStoredCookieConsent().analytics
  ) {
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search + location.hash,
    });
  }
};
